;(function($, undefined) {
    /**
     * View model constructor for Attachment Picker
     */
    app.registerConstructor("CandidateProfile", function(opts) {
            var self = this;
            this.__init__ = function() {
                //init fonts for CVMessageResizer
                var resizer = $("#CVMessageResizer"), CVMField = $("textarea.CVMessage");
                resizer.css({
                    position: 'absolute',
                    top: -10000,
                    left: -10000,
                    width: CVMField.width() - parseInt(CVMField.css('paddingLeft')) - parseInt(CVMField.css('paddingRight')),
                    fontSize: CVMField.css('fontSize'),
                    fontFamily: CVMField.css('fontFamily'),
                    lineHeight: CVMField.css('lineHeight'),
                    resize: 'none'
                }).show()
            };
            this.noteLengthLimit = ko.observable(4000);
            this.$$FORM_SELECTOR = "form.candidate-profile-tab-form";
            this.mandatoryInfo = ko.observable("");
            this.form = {};
            _.each(opts.form, function(field) {
                self.form[field] = ko.observable()
            });
            this.form.foreignState = ko.observable();
            this.fields = ko.viewmodel.fromModel(opts.fields);
            if (this.form.website1) this.form.website1 = this.form.website1.extend({url: "http"});
            if (this.form.website2) this.form.website2 = this.form.website2.extend({url: "http"});
            this.style = {
                fieldWidth: ko.observable(270)
            };

            this.__resize__ = function() {
                var fieldWidth=Math.min($("#rasp_profile_tmpl").width()/2 - 20, 270);
                self.style.fieldWidth(fieldWidth);
                $("div.select2-container").css("min-width", fieldWidth + "px");
                $(".inputfield").css("width", fieldWidth + "px")
            };

            this.canSubmit = function() {
                if ($(self.$$FORM_SELECTOR).validationEngine("validate")) {
                    return true
                } else {
                    app.vm.Global.showClientMessage({summary: "Please correct the invalid fields before submit.", severity: "error"});
                    return false;
                }
            };
            this.updateBackup = function() {
                self.formBackup = ko.toJS(self.form);
                if (PF('uiDateAvailable')) {
                    self.formBackup.dateAvailable = PF('uiDateAvailable').getDate()
                }
            };
            this.reset = function(data, event) {
                for (var p in self.formBackup) {
                    if (self.formBackup.hasOwnProperty(p) && self.form.hasOwnProperty(p)) {
                        self.form[p](self.formBackup[p])
                    }
                }

                //reset complex components
                $("select.prefEmpType").select2("val", self.formBackup.employmentTypes);
                $("select.prefLocation").select2("val", self.formBackup.preferLocations);
                if (PF('uiDateAvailable')) {
                    PF('uiDateAvailable').setDate(self.formBackup.dateAvailable)
                }

                app.vm.Global.showClientMessage({summary: "Form has been reset.", severity: "info"});
                event && event.stopPropagation()
            };
            this.form.CVMessage.subscribe(function(newValue) {
                function times(string, number) {
                    for (var i = 0, r = ''; i < number; i++) r += string;
                    return r;
                }
                _.find(this.__elements__, function(root) {
                    var el = $(root).find("textarea.CVMessage");
                    var h = el.height();
                    var resizer = $("div#CVMessageResizer");
                    if (resizer.width() != el.width()) resizer.width(el.width());
                    var val = newValue.replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/&/g, '&amp;').replace(/\n$/, '<br/>&nbsp;').replace(/\n/g, '<br/>').replace(/ {2,}/g, function(space) {
                        return times('&nbsp;', space.length - 1) + ' '
                    });
                    resizer.html(val);
                    var realH = resizer.height();
                    if (h != realH) {
                        el.height(Math.max(realH + 20, 100))
                    }
                })
            }, this);

            this.updateCurrentSalaryFromSlider = function(event, ui) {
                self.form.currentSalary(ui.value)
            };

            this.updateDesiredSalaryFromSlider = function(event, ui) {
                self.form.desiredSalary(ui.value)
            }

            this.customMultiCheckboxMenu = function (pfWidgetId, maxSize)
            {
                setTimeout(function (){ 

                    var innerHelperList = $(PF(pfWidgetId).label.prevObject[0]).find('div.ui-helper-hidden');
                    var selected = PF(pfWidgetId).getJQ().find(':checked').not('[readonly="readonly"]').map(function(){return $( this )}).get();
                    
                    if(selected && selected.length > 0)
                    {
                        var innerContainerList = $(PF(pfWidgetId).label.prevObject[0]).find('ul.ui-selectcheckboxmenu-multiple-container')
                        
                        if(selected.length > maxSize)
                        {
                            var listSize = selected.length;
                            innerContainerList[0].innerHTML = '<li class=\ "ui-selectcheckboxmenu-token ui-state-active ui-corner-all\" data-item-value=\ "'+ listSize + ' Items Selected' +'\"> <span class=\ "ui-selectcheckboxmenu-token-label\">'+ listSize + ' Items Selected' +'</span> </li>';
                        }
                        else {

                            var selectedLabels = [];
                            $(selected).each(function(){
                                    selectedLabels.push([$(this)[0].id, $(this)[0].value]);
                                });
                            
                            var newContent = '';
                            
                            $(selectedLabels).each(function(){
                                newContent += ' <li class=\ "ui-selectcheckboxmenu-token ui-state-active ui-corner-all\" data-item-value=\ "'+ this[1] +'\">'+
                                                '<span class=\ "ui-selectcheckboxmenu-token-icon ui-icon ui-icon-close\"></span>'+
                                                '<span class=\ "ui-selectcheckboxmenu-token-label\">'+ $(innerHelperList).find('input[id="' + this[0] + '"]')[0].value +'</span>'+
                                            ' </li> ';
                                });
                            
                            innerContainerList[0].innerHTML = newContent;
                        }
                    }
                    else {
                        var title = PF(pfWidgetId).jq.attr("title");
                        var children = $(PF(pfWidgetId).jqId).children('.ui-selectcheckboxmenu-multiple-container');
                        if(children.text() == "")
                        {
                            $(children)[0].innerHTML = '<li class="LABEL_TITLE_'+pfWidgetId+'">'+'Please select...'+'</li>';
                        }
                    }
                } ,0);
            }

    });

})(jQuery);
